var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFactory = function SvgFactory(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.2,
    d: "M21 9v12H1V9l7-3v2l5-2v3zm-4.8-1.5L17 1h3l.8 6.5h-4.6ZM10 17h2v-4h-2zm-4 0h2v-4H6zm10-4h-2v4h2z"
  })));
};
export default SvgFactory;